import React from 'react';
import { useHistory } from 'react-router-dom';
import { CcIcon } from '@utp/components-react';
import Spinner from '../../../../components/Spinner';
import { ContainerProcedure } from '../requests/ChangeCareerCampusModality/info/components';
import {
  ContainerHeader,
  ContainerContent,
  FooterCard,
  DetailButton,
  IconCertification,
  ProcedureTitle,
  CardRectangle,
  ProcedureCardHeader,
  ProcedureCardBody,
  ProceduresCardDates,
  ProceduresCardButtonContainer,
  PaginationContainer,
  ChevronContainer,
  PaginationItems,
  ContainerGrid,
  ProceduresCardContainerV2
} from './styled';
import IconRightPurpleArrow from '../../../../../assets/icons/Right-Purple-Arrow.svg';
import IconSolicitudes from '../../../../../assets/icons/icon-request.svg';
import IconConstancias from '../../../../../assets/icons/icon-autogestionables.svg';
import IconScholarship from '../../../../../assets/icons/icon-becas.svg';
import iconInfo from '@/assets/icons/info-grey.svg';
import { Text, Label } from '../../../../components';
import { UtpButton } from '../scholarships/bse/home/Components/bseStyle';
import routes from '../../../../components/Routes/routingMap';
import StatusRequest from '../../components/Cards/request/Status';
import IDHelpers from '../../../../../core/helpers/IDHelper';
import TextHelper from '../../../../../core/helpers/TextHelper';
import Select from '../../../../reusables/Select';
import EmptyStateProcedureMessage from '../../components/EmptyStateProcedureMessage';
import { ViewDetails } from '../../components/Cards/request';
import { SubsectionHeader } from '@/presentation/reusables/SectionHeader';

interface ProceduresCreatedViewProp {
  isLoadingProcedures: boolean;
  handleChangeSelectYear: (year: string) => void;
  years: string[];
  selectedYear: string;
  totalPages: number[];
  selectedPage: any;
  pickPage: (page: number) => void;
  executeSelectRequest: (procedureID: number, requestID: number) => void;
  handlerBack: any;
}

const ProceduresCreatedView = (props: ProceduresCreatedViewProp) => {
  const {
    isLoadingProcedures,
    handleChangeSelectYear,
    years,
    selectedYear,
    totalPages,
    selectedPage,
    pickPage,
    executeSelectRequest,
    handlerBack
  } = props;

  const evalIcon = (type: string) => {
    if (type === 'Constancia') return IconConstancias;
    if (type === 'Beca') return IconScholarship;
    if (type === 'Solicitud') return IconSolicitudes;
    // by default "TICKET_CRM"
    return IconSolicitudes;
  };

  const isNotRegistered = (historyData: any): boolean =>
    historyData?.requestId === 1017 &&
    historyData?.status?.description === 'No registrado';
  const history = useHistory();
  const goToRegisterTicket = () => {
    const paramSendDocs = 'TA0047';
    history.push(
      `${routes.student.procedures.categories.tickets.register}?v=${paramSendDocs}`
    );
  };

  return (
    <div data-testid="cmp-procedures-created-view">
      <ContainerProcedure>
        <ContainerHeader>
          <div>
            <SubsectionHeader
              title="Historial de trámites"
              onClick={handlerBack}
            />
            <div>
              <Label size={14} text="Filtro por año" />
              <div style={{ display: 'flex', marginBottom: 12, width: 310 }}>
                {/* <ProceduresSelectContainer> */}
                <Select
                  itemCount={4}
                  label=""
                  returnObject
                  isDisabled={false}
                  value={selectedYear}
                  items={years?.map((item: string) => ({
                    value: item,
                    name: item
                  }))}
                  placeholder={selectedYear}
                  onChange={(e) => {
                    handleChangeSelectYear(e.value);
                  }}
                  itemName="name"
                  itemValue="value"
                />
                {/* </ProceduresSelectContainer> */}
                {/* <OutsideClickHandler onOutsideClick={CloseToolTip}>
                    <ProcedureTooltipContainer>
                      <TooltipProcedure
                        isTop={!isMobile}
                        visible={showTooltip}
                        onClose={CloseToolTip}
                      >
                        <button type="button" className="tooltipButton">
                          <Icon name="info" size={20} />
                        </button>
                        Solo se mostrará los años con trámites registrados.
                      </TooltipProcedure>
                    </ProcedureTooltipContainer>
                  </OutsideClickHandler> */}
              </div>
            </div>
          </div>
        </ContainerHeader>
        {isLoadingProcedures ? (
          <Spinner />
        ) : (
          <>
            {selectedPage !== undefined ? (
              <ContainerContent>
                <>
                  <ContainerGrid>
                    {selectedPage &&
                      selectedPage?.items?.map((row: any) => (
                        <div key={IDHelpers.generateID()}>
                          <ProceduresCardContainerV2
                            key={IDHelpers.generateID()}
                            data-testid="cmp-cardRequest-hist"
                            isNotRegister={isNotRegistered(row)}
                          >
                            <ProcedureCardHeader>
                              <IconCertification
                                src={evalIcon(row.type)}
                                alt={row.type}
                              />
                              <ProcedureTitle>
                                {TextHelper.elipsis(row.name, 50)}
                              </ProcedureTitle>
                            </ProcedureCardHeader>
                            <CardRectangle />
                            <ProcedureCardBody>
                              <StatusRequest
                                {...row.status}
                                procedureId={row.requestId}
                              />
                            </ProcedureCardBody>
                            <ProceduresCardDates>
                              {ViewDetails({
                                ...row,
                                procedureId: row.requestId
                              })}
                            </ProceduresCardDates>
                            {!isNotRegistered(row) && (
                              <ProceduresCardButtonContainer>
                                <DetailButton
                                  data-testid="cmp-detail-button-hist"
                                  onClick={() => {
                                    executeSelectRequest(
                                      row.procedureId,
                                      row.requestId
                                    );
                                  }}
                                >
                                  <b>
                                    {row.type === 'TICKET_CRM'
                                      ? 'Ir a correo electrónico'
                                      : 'Ver detalle'}
                                  </b>
                                  <img
                                    src={IconRightPurpleArrow}
                                    alt="IconRightPurpleArrow"
                                    style={{ margin: '1px 7px' }}
                                  />
                                </DetailButton>
                              </ProceduresCardButtonContainer>
                            )}
                          </ProceduresCardContainerV2>
                          {isNotRegistered(row) && (
                            <FooterCard>
                              <img
                                src={iconInfo}
                                alt="iconInfo"
                                style={{
                                  width: '20px',
                                  height: '20px',
                                  objectFit: 'contain',
                                  top: '2px',
                                  left: '2px'
                                }}
                              />
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'column',
                                  gap: '4px'
                                }}
                              >
                                <Text fontWeight="400">
                                  Tu trámite no pudo ser registrado. Reporta el
                                  inconveniente en
                                  <UtpButton
                                    data-testid="cmp-utpbutton-card"
                                    className="Urlcolor link-underline"
                                    onClick={() => goToRegisterTicket()}
                                  >
                                    registro de quejas y reclamos.
                                  </UtpButton>
                                </Text>
                              </div>
                            </FooterCard>
                          )}
                        </div>
                      ))}
                  </ContainerGrid>
                  {totalPages && totalPages.length > 1 && (
                    <PaginationContainer>
                      <div style={{ display: 'flex' }}>
                        <ChevronContainer
                          data-testid="cmp-first-pickPage"
                          className={selectedPage?.page === 1 ? 'disable' : ''}
                          onClick={() => {
                            if (selectedPage?.page > 1) {
                              pickPage(selectedPage?.page - 1);
                            }
                          }}
                        >
                          <CcIcon name="chevron-left" size={24} />
                        </ChevronContainer>
                        {totalPages &&
                          totalPages?.map((row) => (
                            <PaginationItems
                              key={row}
                              onClick={() => pickPage(row)}
                              className={
                                selectedPage?.page === row ? 'active' : ''
                              }
                            >
                              {row}
                            </PaginationItems>
                          ))}
                        <ChevronContainer
                          data-testid="cmp-lastPage"
                          className={
                            selectedPage?.page === totalPages?.length
                              ? 'disable'
                              : ''
                          }
                          onClick={() => {
                            if (selectedPage?.page !== totalPages?.length) {
                              pickPage(selectedPage?.page + 1);
                            }
                          }}
                        >
                          <CcIcon name="chevron-right" size={24} />
                        </ChevronContainer>
                      </div>
                    </PaginationContainer>
                  )}
                </>
              </ContainerContent>
            ) : (
              <div style={{ margin: '32px auto' }}>
                <EmptyStateProcedureMessage />
              </div>
            )}
          </>
        )}
        {/* <HomeFooter /> */}
      </ContainerProcedure>
    </div>
  );
};

export default ProceduresCreatedView;
